import * as yup from 'yup'


export const InfoValidation = yup.object().shape({
  name: yup.string().required(),
  category_id: yup.string().required(),
  description: yup.string().notRequired(),
  website: yup.string().url().notRequired()
});

export const RoleValidation = yup.object().shape({
  name: yup.string().required(),
  display_name: yup.string().required()
});

export const UserValidation = yup.object().shape({
  first_name: yup.string().required(),
  last_name: yup.string().required(),
  email: yup.string().required().email(),
  phone: yup.string().required(),
  // branch_id: yup.string().required(),
  // pos_id: yup.string().required(),
  role_id: yup.string().required()
});

export const HeadOfficeValidation = yup.object().shape({
  country_id: yup.string().required(),
  state_id: yup.string().required(),
  town: yup.string().notRequired(),
  street: yup.string().notRequired(),
  address: yup.string().notRequired(),
  building: yup.string().notRequired(),
});

export const SocialMediaValidation = yup.object().shape({
  facebook: yup.string().notRequired(),
  linkedIn: yup.string().notRequired(),
  instagram: yup.string().notRequired(),
  twitter: yup.string().notRequired(),
});

export const BranchValidation = yup.object().shape({
  name: yup.string().required(),
  address: yup.string().notRequired(),
  location: yup.string().required(),
  opens_at: yup.string().required(),
  closes_at: yup.string().required(),
});

export const SettlementBankValidation = yup.object().shape({
  bank_name: yup.string().required(),
  account_name: yup.string().required(),
  account_no: yup.number().required(),
});

export const CashbackValidation = yup.object().shape({
  branch_id: yup.number().required(),
  start: yup.number().required(),
  end: yup.number().required(),
  is_fixed: yup.boolean().required(),
  // fixed_bonus: yup.number().test('required', '', (value) => {
  //   if (value) console.log('Is fixed?', yup.ref('is_fixed'))
  //   if (value) return yup.ref('is_fixed')
  // }),
  // bonus_percentage: yup.number().test('required', '', (value) => {
  //   if (value) return !yup.ref('is_fixed')
  // }),
  fixed_bonus: yup.number().when(
    'is_fixed', {
    is: true,
    then: yup.number().required('Enter a fixed value')
  }
  ),
  bonus_percentage: yup.number().when(
    'is_fixed', {
    is: false,
    then: yup.number().required('Enter a bonus value')
  }
  )
});


export const AccountSettingsValidation = yup.object().shape({
  old_password: yup.string()
    .required(),

  new_password: yup.string()
    .required()
    .test('caps', '', (value) => value && /[A-Z]/.test(value))
    .test('num', '', (value) => value && /[0-9]/.test(value))
    .min(8),

  new_password_confirmation: yup.string()
    .required()
    .oneOf([yup.ref('new_password'), null], 'Passwords must match')
    .test('match', '', function (value) {
      if (value) return this.parent.new_password === value
    }
    )
});